import React, { useContext, useEffect } from 'react';
import { ThemeContext } from '../../context/ThemeProvider';
import Header from '../landing/components/Header';
import { landingPageConfig } from '../../../app_constant/landingPageConfig';

const OnboardingLayout = ({ children }) => {
  const { theme, currentTheme, setCurrentTheme } = useContext(ThemeContext);
  const {
    appConfig
  } = landingPageConfig;
  const onToggleTheme = () => {
    const body = document.body;
    const newTheme = currentTheme === "light" ? "dark" : "light";
    localStorage.setItem("Theme", newTheme);
    setCurrentTheme(newTheme);
    body.classList.toggle("dark", newTheme === "dark");
  };

  

  return (
    <div style={{
      minHeight: '100vh',
      background: theme?.background?.main,
      //background: `linear-gradient(135deg, ${theme.backgrounds.secondary} 0%, ${theme.backgrounds.primary} 100%)`,
      color: theme.text.primary,
      //transition: 'all 0.3s ease',
      position: 'relative',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      
        <Header logo={appConfig.logo} onThemeChange={onToggleTheme} currentTheme={currentTheme} theme={theme} />
        <div style={{ width: '100%', maxWidth: 1200 }}>
        <div className="container mx-auto px-4 py-6 relative" style={{ zIndex: 1 }}>
          <div className="relative z-10">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingLayout; 